import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";
import { visitMessage } from "@/lib/services";

const FIELDS = [
  ["company_name", "Nome da empresa", "Ex.: Minha Empresa Ltda"],
  ["responsible_name", "Responsável", "Quem assina as mensagens"],
  ["phone", "Telefone da empresa", "(00) 00000-0000"],
];

const SAMPLE = { client_name: "Cliente", service_type: "caixa", execution_date: "2026-10-08" };

export const CompanyDialog = ({ open, company, onClose, onSaved }) => {
  const [f, setF] = useState({ company_name: "", responsible_name: "", phone: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && company) setF(company);
  }, [open, company]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/settings/company", f);
      onSaved(data);
      toast.success("Dados da empresa salvos.");
      onClose();
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-slate-700 bg-slate-900 sm:max-w-md" data-testid="company-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold">Dados da empresa</DialogTitle>
          <DialogDescription>Aparecem nas mensagens de WhatsApp e no relatório mensal.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {FIELDS.map(([k, label, ph]) => (
            <div key={k} className="space-y-1.5">
              <Label htmlFor={`company_${k}`}>{label}</Label>
              <Input id={`company_${k}`} value={f[k]} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-11 bg-slate-950" data-testid={`company-${k.replace("_", "-")}-input`} />
            </div>
          ))}
          <div className="rounded-lg border border-slate-700 bg-slate-950 p-3 text-xs text-slate-300" data-testid="company-message-preview">
            <div className="mb-1 font-semibold uppercase tracking-wider text-slate-500">Prévia do WhatsApp</div>
            {visitMessage(SAMPLE, f)}
          </div>
          <DialogFooter className="gap-2">
            <Button type="button" variant="ghost" onClick={onClose} data-testid="company-cancel">Cancelar</Button>
            <Button type="submit" disabled={saving} className="rounded-full font-semibold" data-testid="company-save">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
